import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom'
import { MenuItem } from '@material-ui/core'

type ClickHandel = (event: React.MouseEvent<HTMLElement>) => void;
export interface AppMenuItemComponentProps {
    className?: string;
    link?: string | null; // because the InferProps props allows alows null value
    expandable?: boolean | null;
    onClick?: ClickHandel;
}

export const AppMenuItemComponentPropsReact = {
    className: PropTypes.string,
    link: PropTypes.string,
    expandable: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
}


const AppMenuItemComponent: React.FC<AppMenuItemComponentProps> = props => {
    const { className, onClick, link, expandable, children } = props
    const MyLink = (props: NavLinkProps, ref: React.Ref<HTMLAnchorElement> | undefined) => <NavLink exact {...props} innerRef={ref} />
    // If link is not set return the orinary ListItem
    const location = useLocation();

    if (!link || typeof link !== 'string' || expandable) {
        return (
            <MenuItem
                button
                selected={link ? location.pathname.startsWith(link) : false}
                className={className}
                onClick={onClick}>
                {children}
            </MenuItem>

        )
    }

    // Return a LitItem with a link component
    return (
        <MenuItem
            button
            selected={location.pathname == link}
            className={className}
            onClick={onClick}
            component={React.forwardRef(MyLink)}
            to={link}
        > {children}</MenuItem>

    )
}
AppMenuItemComponent.propTypes = AppMenuItemComponentPropsReact
export default AppMenuItemComponent
